import Modal from './modal'

export default Modal
export { default as ModalHeader } from './modalHeader'
export { default as ModalFooter } from './modalFooter'
export { default as ModalBody } from './modalBody'
export * from './constants'
export * from './types'
